import { createContext, useCallback, useContext, useMemo, useState } from 'react'
import { Semester } from '../types'
import { StandaloneData } from '../api/endpoints/sessions'
import { useLocation } from 'react-router-dom'

export type HomeContextData = ReturnType<typeof useHomeContextData>

export const HomeContext = createContext<HomeContextData | null>(null)

export const useHomeContext = () => {
    const context = useContext(HomeContext)

    if (!context) {
        throw Error('useHomeContext hook can be used only inside HomeContextProvider')
    }

    return context
}

const useHomeContextData = () => {
    const location = useLocation()

    const [data, setData] = useState<StandaloneData | null>(null)
    const [selectedContent, setSelectedContent] = useState<any>('live')
    const [currency, setCurrency] = useState<any>(null)
    const [hostId, setHostId] = useState<any>(null)
    const [semesters, setSemesters] = useState<Semester[]>([])
    const [momenceLeadId] = useState<string | null>(new URLSearchParams(location.search).get('momenceLeadId'))

    const attachMomenceLeadId = useCallback(
        (url: string) => {
            if (!momenceLeadId) {
                return url
            }

            try {
                const parsedUrl = new URL(url)
                parsedUrl.searchParams.append('momenceLeadId', momenceLeadId)

                return parsedUrl.toString()
            } catch (e) {
                return url
            }
        },
        [momenceLeadId]
    )

    return useMemo(
        () => ({
            data,
            setData,
            selectedContent,
            setSelectedContent,
            currency,
            setCurrency,
            hostId,
            setHostId,
            semesters,
            setSemesters,
            momenceLeadId,
            attachMomenceLeadId,
        }),
        [currency, data, hostId, selectedContent, semesters, momenceLeadId, attachMomenceLeadId]
    )
}

export const HomeContextProvider = ({ children }: { children: React.ReactNode }) => {
    const value = useHomeContextData()

    return <HomeContext.Provider value={value}>{children}</HomeContext.Provider>
}
